module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "smog-city.7283374c.png";